import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_032.jpg';
// page.coloring = [
//   {
//     id: 'page016_game2',
//     icon: 'ikona_cw2',
//     coloringObj: {
//       text: 'Wybierz rysunek, aby go pokolorować. Z jakich baśni pochodzą te ilustracje?',
//       audio: 'audio/z16c2.mp3',
//       items: [
//         { name: 'page016_game7', path: 'files/page032/55862_0_basnie-rysunki konturowe il1_original2.png' },
//         { name: 'page016_game8', path: 'files/page032/55862_0_basnie-rysunki konturowe il2_original2.png' },
//         { name: 'page016_game9', path: 'files/page032/55862_0_basnie-rysunki konturowe il3_original2.png' },
//       ],
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 200,
//     },
//     // rectangle: {
//     //   id: 'page016_rect2',
//     // },
//   },
// ];
page.paint = [
  {
    id: 'page016_game3',
    icon: 'ikona_cw5',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Dokończ rysunek i go pokoloruj.',
      audio: 'files/page016/z16c3.mp3',
      item: {
        path: 'informatyka/files/page016/z.16cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
        height: 'auto',
      },
    },
    pos: {
      x: LEFT,
      y: 800,
    },
  },
];
page.games = [
  {
    id: 'page016_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page016_game4',
    tooltip: '',
    icon: 'ikona_cw6',
    pos: {
      x: LEFT,
      y: 1000,
    },
  },
  {
    id: 'page016_game7',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page016_game8',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page016_game9',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
];
page.images = [
  {
    imageId: 'page032_zoom0',
    rectangle: {
      x: 120,
      y: 560,
      width: 1000,
      height: 650,
    },
    imageSrc: 'images/page032/033 2.jpg',
  },
  {
    imageId: 'page032_zoom1',
    rectangle: {
      x: 880,
      y: 1080,
      width: 1000,
      height: 650,
    },
    imageSrc: 'images/page032/033 1.jpg',
  },
  {
    imageId: 'page032_zoom2',
    rectangle: {
      x: 60,
      y: 1450,
      width: 800,
      height: 470,
    },
    imageSrc: 'images/page032/032 7.jpg',
  },
  {
    imageId: 'page032_zoom3',
    rectangle: {
      x: 380,
      y: 1800,
      width: 800,
      height: 470,
    },
    imageSrc: 'images/page032/032 6.jpg',
  },
  {
    imageId: 'page032_zoom4',
    rectangle: {
      x: 965,
      y: 2040,
      width: 800,
      height: 470,
    },
    imageSrc: 'images/page032/032 5.jpg',
  },
];
page.gallery = [
  {
    id: '_gallery1',
    icon: 'ikona_cw7',
    pos: {
      x: LEFT,
      y: 1200,
    },
    items: [
      {
        imageSrc: 'gallery/page032/008.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Praca grafika komputerowego',
      },
      {
        imageSrc: 'gallery/page032/026.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Praca grafika komputerowego',
      },
      {
        imageSrc: 'gallery/page032/001.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Grafik komputerowy',
      },
      {
        imageSrc: 'gallery/page032/014.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Gra komputerowa',
      },
      {
        imageSrc: 'gallery/page032/005.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Postacie z gier komputerowych',
      },
      {
        imageSrc: 'gallery/page032/007.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Pikselowe miasto',
      },
      {
        imageSrc: 'gallery/page032/010.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Pikselowy kosmos',
      },
      {
        imageSrc: 'gallery/page032/003.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Wikingowie i morski potwór',
      },
      {
        imageSrc: 'gallery/page032/029.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Pies',
      },
      {
        imageSrc: 'gallery/page032/023.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Lekarz',
      },
      {
        imageSrc: 'gallery/page032/018.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Internet i urządzenia komputerowe',
      },
      {
        imageSrc: 'gallery/page032/020.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Model samochodu',
      },
      {
        imageSrc: 'gallery/page032/017.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Samochód rozłożony na części',
      },
      {
        imageSrc: 'gallery/page032/022.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Model samolotu wojskowego',
      },
      {
        imageSrc: 'gallery/page032/006.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Grafika 3D – samolot wojskowy',
      },
      {
        imageSrc: 'gallery/page032/021.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Obiekty 3D',
      },
      {
        imageSrc: 'gallery/page032/012.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Etapy powstawania grafiki 3D',
      },
      {
        imageSrc: 'gallery/page032/027.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Model domu',
      },
      {
        imageSrc: 'gallery/page032/011.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Miasto w grafice 3D',
      },
      {
        imageSrc: 'gallery/page032/015.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Projekt osiedla',
      },
      {
        imageSrc: 'gallery/page032/025.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Miasto przyszłości',
      },
      {
        imageSrc: 'gallery/page032/024.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Atlantyda ',
      },
      {
        imageSrc: 'gallery/page032/009.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Grafika baśniowa',
      },
      {
        imageSrc: 'gallery/page032/028.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Grafika baśniowa',
      },
      {
        imageSrc: 'gallery/page032/016.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Postać baśniowa',
      },
      {
        imageSrc: 'gallery/page032/030.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Robocik',
      },
      {
        imageSrc: 'gallery/page032/013.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Biegacze',
      },
      {
        imageSrc: 'gallery/page032/019.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Kula Ziemska w 3D',
      },
      {
        imageSrc: 'gallery/page032/004.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Astronauta',
      },
      {
        imageSrc: 'gallery/page032/002.jpg',
        alt: 'Grafika komputerowa',
        dataDescription: 'Wszechświat',
      },
    ],
  },
];
export default page;
